<ng-template #preHeader>
    SIGN IN <shared-disabled-text>/ SIGN UP</shared-disabled-text>
</ng-template>
<shared-auth-header [preHeader]="preHeader">
    Welcome Back {{firstName$ | async}}
</shared-auth-header>

<shared-form-for-sign-in-password [modal]="true" [cellNumber]="accountLogin$ | async">
</shared-form-for-sign-in-password>